import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<div class={style.header}>
		<div class="logoC">
		<Link activeClassName={style.active} href="/">		
		<img src="/assets/logo.png"/>
		</Link>
	
		</div>
	<nav>
			
			<Link activeClassName={style.active} href="/shop">shop</Link>
			<Link activeClassName={style.active} href="/videos">videos</Link>
			<Link activeClassName={style.active} href="/music">music</Link>
			<Link activeClassName={style.active} href="/terms">terms</Link>
			<Link activeClassName={style.active} href="/contact">contact</Link>
			
			
		</nav>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js